module.exports = __webpack_public_path__ + "img/wl_v1.6e2a9504.png";